import { TConfigUI } from 'src/types/followup'
import { EMedEventTypes, TMedEventUI } from 'src/types/med-event'
import { TCompletedMedEvent } from '../generic-followup-form.type'
import { TMedEventForm } from 'src/components/followup/generic-followup-form.service'

const getValuesFromCompletedMedEvent = (completedMedEvent: TCompletedMedEvent) => {
  return {
    date: completedMedEvent.date ? new Date(completedMedEvent.date) : undefined,
    convocationDate: completedMedEvent.convocationDate
      ? new Date(completedMedEvent.convocationDate)
      : undefined,
    UserId: completedMedEvent.UserId,
    LocationId: completedMedEvent.LocationId,
  }
}

export const getValuesFromConfig = (medEventUI: TMedEventUI) => {
  const hasMedEventDefaultValueForDate = medEventUI?.properties.some(
    (property) => property.withDefaultValue && property.fieldName === 'date',
  )
  return hasMedEventDefaultValueForDate ? { ['date']: new Date(Date.now()) } : {}
}

export const getDefaultValues = (
  medEventToShow?: TMedEventUI,
  completedMedEvent?: TCompletedMedEvent,
  isEditing?: boolean,
): TMedEventForm | object => {
  if (!medEventToShow) return {}
  if (isEditing && completedMedEvent) {
    return getValuesFromCompletedMedEvent(completedMedEvent)
  }

  return getValuesFromConfig(medEventToShow)
}

const getCompletedMedEventsIdsOfType = (
  validationType: EMedEventTypes,
  medEventsUI: TMedEventUI[],
  formValues: Record<string, string>,
) => {
  const medEventOfType = medEventsUI
    .filter((followupMedEventUi) => followupMedEventUi.MedEvent.type === validationType)
    .map((followupMedEvent) => followupMedEvent.MedEvent.id.toString())
  const keysOfCompletedMedEvents = Object.keys(formValues).map((key) => key.split('-')[0])
  const completedMedEventsIds = [...new Set(keysOfCompletedMedEvents)] as string[]
  return completedMedEventsIds.filter((completedMedEventId) => medEventOfType.includes(completedMedEventId))
}

export const getValidationErrors = (formValues: Record<string, any>, configUI: TConfigUI) => {
  return configUI.validationRules?.filter((validationRule) => {
    if (validationRule?.min && validationRule.min >= 1) {
      const medEventCompletedOfType = getCompletedMedEventsIdsOfType(
        validationRule.type,
        configUI.medEventsUI,
        formValues,
      )
      const isValidationRespected = validationRule.min <= medEventCompletedOfType.length
      return !isValidationRespected
    }
    return false
  })
}
